export default __webpack_public_path__ + "static/media/image4.c5c9f0a1.png";